<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    ref="pagelist"
    :showSingleActions="showSingleActions"
    :export-data-options="exportDataOptions">
    <template v-slot:group-actions-append>
      <div class="d-flex align-items-center">
        <a-checkbox class="ml-2" v-model="withRate">{{$t('bill.only_show_with_rates')}}</a-checkbox>
        <!-- <help-tooltip :text="$t('bill.only_show_with_rates_tip')" /> -->
      </div>
    </template>
  </page-list>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getDistinctFieldFilter, getBrandDistinctFilter } from '@/utils/common/tableFilter'
import storage from '@/utils/storage'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

const with_rate_key = '__oc_rates_with_rate_'

export default {
  name: 'BillRateList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
    cloudEnv: {
      type: String,
    },
    showSearchbox: {
      type: Boolean,
      default: true,
    },
    showSingleActions: {
      type: Boolean,
      default: true,
    },
    rateSetId: String,
  },
  data () {
    const withRate = storage.get(with_rate_key, true)
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'rates',
        apiVersion: 'v1',
        getParams: this.getParams,
        filterOptions: {
          id: { field: 'id', label: 'ID' },
          resource_type: getDistinctFieldFilter({
            field: 'resource_type',
            label: this.$t('bill.text_73'),
            mapper: (data) => {
              return data.map(item => {
                return {
                  key: item.key,
                  label: this.$te(`rate_resource_type.${item.key}`) ? this.$t(`rate_resource_type.${item.key}`) + `(${item.key})` : item.key,
                }
              })
            },
          }),
          usage_type: getDistinctFieldFilter({
            field: 'usage_type',
            label: this.$t('bill.rate.title.usage_type'),
            mapper: (data) => {
              return data.map(item => {
                return {
                  key: item.key,
                  label: this.$te(`rate_usage_type.${item.key}`) ? this.$t(`rate_usage_type.${item.key}`) + `(${item.key})` : item.key,
                }
              })
            },
          }),
          brand: getBrandDistinctFilter(),
          // precision: {
          //   label: this.$t('bill.rate.title.precision'),
          //   dropdown: true,
          //   filter: true,
          //   items: [
          //     { key: 'second', label: this.$t('rate_precision.second') },
          //     { key: 'day', label: this.$t('rate_precision.day') },
          //     { key: 'month', label: this.$t('rate_precision.month') },
          //   ],
          //   formatter: (val) => {
          //     return `precision.equals(${val})`
          //   },
          // },
          // price_type: {
          //   label: this.$t('bill.rate.title.price_type'),
          //   dropdown: true,
          //   filter: true,
          //   items: [
          //     { key: 'amount', label: this.$t('rate_price_type.amount') },
          //     { key: 'amount_range', label: this.$t('rate_price_type.amount_range') },
          //     { key: 'fixed_range', label: this.$t('rate_price_type.fixed_range') },
          //   ],
          //   formatter: (val) => {
          //     return `price_type.equals(${val})`
          //   },
          // },
        },
        hiddenColumns: ['created_at'],
      }),
      groupActions: [
        {
          label: this.$t('bill.text_258'),
          action: () => {
            this.list.onManager('get', {
              managerArgs: {
                id: 'sync',
              },
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
        {
          label: this.$t('system.text_129'),
          permission: 'rates_delete',
          action: () => {
            this.createDialog('DeleteResDialog', {
              vm: this,
              title: this.$t('system.text_129'),
              name: this.$t('dictionary.project'),
              data: this.list.selectedItems,
              columns: this.columns,
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              validate: this.list.allowDelete(),
            }
          },
          hidden: () => this.rateSetId !== 'default',
        },
      ],
      withRate,
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: this.$t('bill.text_38'),
        items: this.columns,
        downloadType: 'local',
      }
    },
  },
  watch: {
    cloudEnv (val) { // 这里指 虚拟资源费率、裸金属服务器费率、GPU卡费率
      this.list.getParams = { ...this.list.getParams, res_type: val }
      this.fetchData()
    },
    withRate (val) {
      this.list.reset()
      this.list.refresh()
      storage.set(with_rate_key, val)
    },
  },
  created () {
    this.fetchData()
    this.$bus.$on('refreshRateList', () => {
      this.fetchData()
    })
  },
  methods: {
    getParams () {
      const ret = {
        details: true,
        admin: this.$store.getters.isAdminMode,
        // res_type: this.cloudEnv,
        rate_set_id: this.rateSetId,
      }
      if (this.withRate) ret.with_rate = true
      return ret
    },
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillRateSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
        data: row,
        rateSetId: this.rateSetId,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
